import HttpService from '@picsart/rc/services/http';

async function fetchData(url: string, options: any = {}): Promise<any> {
  const { headers: optionsHeaders } = options;

  const requestOptions = {
    ...options,
    ...HttpService.getOptions({ headers: { ...optionsHeaders, platform: 'website' } }),
  };

  try {
    const data = await HttpService.get(url, requestOptions);
    if (data.status !== 'success') {
      throw new Error(`Can't get User data::: ${url}`);
    }
    return data;
  } catch (e) {
    console.trace({ path: 'src/api/user', url, e });
    return e instanceof Response ? { ...(await e?.json()), statusCode: e.status } : {};
  }
}

export default fetchData;
